<template>
  <div ref="filterBar">
    <ClientOnly>
      <FilterBar
        v-model="filterBarModel"
        @reset="resetFilters"
        @sort="setSortBy"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const filterBar = useTemplateRef('filterBar')
const componentType = ref('Events')
const { resetFilters, setSortBy, filterBarModel } = useFilterBar({
  componentType,
  filterBar,
})
</script>
